import styled from 'styled-components';
export const PremiumStatusBlockContainer = styled.div `
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  background-color: ${({ theme }) => theme.colors.beige_4};
  padding-inline: ${({ theme }) => theme.appearance.spacing * 1.5}px;
  padding-block-end: ${({ theme }) => theme.appearance.spacing * 2}px;
  padding-block-start: ${({ theme }) => theme.appearance.spacing * 1}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;
